import React from 'react'
import classNames from 'classnames';

import Checkbox from '@material-ui/core/Checkbox';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ReactTooltip from 'react-tooltip'
import { FaInfoCircle } from 'react-icons/fa';

/*
Args:
    classes: Classes for React CSS
    handleInputChange: Function which updates the state in the Form based on user inputs
    title: String;  The name displayed above the switch to the user
    label: String; The description which appears to the right of the switch
    name: String; The name of the variable referenced in the Form's state
    value: String; The name of the variable referenced in the Form's state
    tooltip: String; information which may help the user complete the form
*/

const SingleSwitch = props => (
    <div>
        <div>
            {props.title && <b>{props.title}</b>} {props.tooltip && <FaInfoCircle data-tip data-for={props.name}/>}

            <ReactTooltip id={props.name} place="right" type="light" effect="solid">
                {props.tooltip}
            </ReactTooltip>
        </div>

        <FormGroup row className={classNames(props.classes.margin, props.classes.textField)}>
            <FormControlLabel
                key={props.value}
                control={
                    <Checkbox
                        name={props.name}
                        checked={props.value}
                        onChange={props.handleInputChange}
                        value={props.name}
                        color="primary"/>
                }
                label={props.label}/>
        </FormGroup>
    </div>
)

export default SingleSwitch;
